import { createAction, props } from '@ngrx/store';
import { OrientationStatus } from 'src/app/shared/models/enums/orientation-status.enum';
import { OrientationContract } from 'src/app/travelxnew/models/orientation-profile/orientation-contract.model';
import { OrientationOverview } from 'src/app/travelxnew/models/orientation-profile/orientation-overview.model';
import { OrientationSection } from 'src/app/travelxnew/models/orientation-profile/orientation-section.enum';
import { OrientationCompliance } from 'src/app/travelxnew/models/orientation-profile/orientation-compliance.model';
import { OrientationPayroll } from 'src/app/travelxnew/models/orientation-profile/orientation-payroll.model';
import { OrientationHousing } from 'src/app/travelxnew/models/orientation-profile/orientation-housing.model';
import { OrientationBenefit } from 'src/app/travelxnew/models/orientation-profile/orientation-benefit.model';
import { OrientationFacility } from 'src/app/travelxnew/models/orientation-profile/orientation-facility.model';

export const getOrientationContractsByCandidateId = createAction(
    '[ORIENTATION CONTRACTS COMPONENT] Get Orientation Contracts',
    props<{ candidateId: number }>()
);
export const getOrientationContractsByCandidateIdSuccess = createAction(
    '[ORIENTATION CONTRACTS API] Get Orientation Contracts Success',
    props<{ contracts: OrientationContract[]; candidateId: number }>()
);
export const getOrientationContractsByCandidateIdFailure = createAction(
    '[ORIENTATION CONTRACTS API] Get Orientation Contracts Failure',
    props<{ error: string }>()
);

export const setSelectedContract = createAction(
    '[ORIENTATION SELECTED CONTRACT COMPONENT] Set Selected Contract',
    props<{ contractId: number }>()
);
export const clearSelectedContract = createAction('[ORIENTATION SELECTED CONTRACT CLEARED] Clear Selected Contract');

export const updateOrientationStatus = createAction(
    '[ORIENTATION CONTRACTS COMPONENT] Update Orientation Status',
    props<{ candidateId: number; contractId: number; statusId: OrientationStatus }>()
);
export const updateOrientationStatusSuccess = createAction(
    '[ORIENTATION CONTRACTS API] Update Orientation Status Success',
    props<{ candidateId: number; message: string }>()
);
export const updateOrientationStatusFailure = createAction(
    '[ORIENTATION CONTRACTS API] Update Orientation Status Failure',
    props<{ error: string }>()
);

export const setSectionExpandedState = createAction(
    '[ORIENTATION SECTIONS COMPONENT] Set Orientation Section Expanded State',
    props<{ section: OrientationSection; state: boolean }>()
);
export const noopAction = createAction('[ORIENTATION SECTIONS] Do nothing if closing a section');

// Overview Section
export const getOrientationOverview = createAction(
    '[ORIENTATION OVERVIEW COMPONENT] Get Orientation Overview',
    props<{ contractId: number }>()
);
export const getOrientationOverviewSuccess = createAction(
    '[ORIENTATION OVERVIEW API] Get Orientation Contracts Success',
    props<{ overview: OrientationOverview }>()
);
export const getOrientationOverviewFailure = createAction(
    '[ORIENTATION OVERVIEW API] Get Orientation Contracts Failure',
    props<{ error: string }>()
);

// Compliance Section
export const getOrientationCompliance = createAction(
    '[ORIENTATION COMPLIANCE COMPONENT] Get Orientation Compliance',
    props<{ contractId: number }>()
);
export const getOrientationComplianceSuccess = createAction(
    '[ORIENTATION COMPLIANCE API] Get Orientation Compliance Success',
    props<{ compliance: OrientationCompliance }>()
);
export const getOrientationComplianceFailure = createAction(
    '[ORIENTATION COMPLIANCE API] Get Orientation Compliance Failure',
    props<{ error: string }>()
);

// Payroll Section
export const getOrientationPayroll = createAction(
    '[ORIENTATION PAYROLL COMPONENT] Get Orientation Payroll',
    props<{ contractId: number }>()
);
export const getOrientationPayrollSuccess = createAction(
    '[ORIENTATION PAYROLL API] Get Orientation Payroll Success',
    props<{ payroll: OrientationPayroll }>()
);
export const getOrientationPayrollFailure = createAction(
    '[ORIENTATION PAYROLL API] Get Orientation Payroll Failure',
    props<{ error: string }>()
);

// Housing Section
export const getOrientationHousing = createAction(
    '[ORIENTATION HOUSING COMPONENT] Get Orientation Housing',
    props<{ contractId: number }>()
);
export const getOrientationHousingSuccess = createAction(
    '[ORIENTATION HOUSING API] Get Orientation Housing Success',
    props<{ housing: OrientationHousing }>()
);
export const getOrientationHousingFailure = createAction(
    '[ORIENTATION HOUSING API] Get Orientation Housing Failure',
    props<{ error: string }>()
);

// Benefits Section
export const getOrientationBenefits = createAction(
    '[ORIENTATION BENEFITS COMPONENT] Get Orientation Benefits',
    props<{ contractId: number }>()
);
export const getOrientationBenefitsSuccess = createAction(
    '[ORIENTATION BENEFITS API] Get Orientation Benefits Success',
    props<{ benefit: OrientationBenefit }>()
);
export const getOrientationBenefitsFailure = createAction(
    '[ORIENTATION BENEFITS API] Get Orientation Benefits Failure',
    props<{ error: string }>()
);

// Facility Section
export const getOrientationFacility = createAction(
    '[ORIENTATION FACILITY COMPONENT] Get Orientation Facility',
    props<{ contractId: number }>()
);
export const getOrientationFacilitySuccess = createAction(
    '[ORIENTATION FACILITY API] Get Orientation Facility Success',
    props<{ facility: OrientationFacility }>()
);
export const getOrientationFacilityFailure = createAction(
    '[ORIENTATION FACILITY API] Get Orientation Facility Failure',
    props<{ error: string }>()
);
